import { keepDisplayedTimestamp } from "@/lib/utils";
import type { ChatHistoryResponse, ChatMessage } from "@/types/discuss.types";

/**
 * Prefer the send-time already in cache when get_chat refetches. Discuss
 * history often stamps date-only or midnight-in-user-TZ values that would
 * change the clock the user just saw.
 */
export function mergeDiscussHistory(
  cached: ChatHistoryResponse | undefined,
  incoming: ChatHistoryResponse
): ChatHistoryResponse {
  const cachedTurns = cached?.prev_chat ?? [];
  const incomingTurns = incoming.prev_chat ?? [];
  const usedCached = new Set<number>();
  const prev_chat = incomingTurns.map((incomingTurn) => {
    const cachedIndex = cachedTurns.findIndex((turn, index) => {
      if (usedCached.has(index)) return false;
      return turn.question === incomingTurn.question;
    });
    if (cachedIndex < 0) return incomingTurn;
    usedCached.add(cachedIndex);
    const cachedTurn: ChatMessage | undefined = cachedTurns[cachedIndex];
    return {
      ...incomingTurn,
      creation_date: keepDisplayedTimestamp(cachedTurn?.creation_date, incomingTurn.creation_date),
    };
  });
  // get_chat can return before a just-sent (or chained) turn is stored.
  // Dropping those cached turns is what made One Click Automation look like
  // it wiped Discuss.
  const leftover = cachedTurns.filter((_, index) => !usedCached.has(index));
  return { ...incoming, prev_chat: [...prev_chat, ...leftover] };
}
